import { ILocale } from '@/config/locales';
import { useRouter } from '@/hooks/useRouter';
import { getSettingsForLocale } from '@/utility/i18n';

export function useLocaleSettings(): ILocale {
  const router = useRouter();

  return getSettingsForLocale(router?.locale);
}
